import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

import { useTheme } from "@emotion/react";
import LockOpenTwoToneIcon from "@mui/icons-material/LockOpenTwoTone";
import SecurityIcon from "@mui/icons-material/Security";
import {
  Avatar,
  Box,
  Button,
  Divider,
  Popover,
  Typography,
  styled,
} from "@mui/material";

import useAuth from "src/hooks/useAuth";

const UserBoxButton = styled(Box)(
  ({ theme }) => `
    display:flex;
    align-items:center;
    justify-content:center;
    padding: 0;
    border:"1px solid #ccc;
`,
);

const MenuUserBox = styled(Box)(
  ({ theme }) => `
        background: ${theme.colors.alpha.black[5]};
        padding: ${theme.spacing(2)};
`,
);

const UserBoxText = styled(Box)(
  ({ theme }) => `
        text-align: left;
        font-size:12px;
`,
);

const UserBoxLabel = styled(Typography)(
  ({ theme }) => `
        font-weight: ${theme.typography.fontWeightBold};
        color: ${theme.palette.secondary.main};
        display: block;
`,
);

const UserBoxDescription = styled(Typography)(
  ({ theme }) => `
        color: ${theme.palette.secondary.light};
        font-size:12px;
`,
);

function HeaderUserbox() {
  const { t } = useTranslation();
  const theme = useTheme();
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const ref = useRef(null);
  const [isOpen, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleLogout = async () => {
    try {
      handleClose();
      await logout();
      navigate("/");
    } catch (err) {
      console.error(err);
    }
  };

  const handleSecurity = async () => {
    try {
      handleClose();
      navigate("/security");
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <UserBoxButton>
        <Button
          ref={ref}
          onClick={handleOpen}
          sx={{
            p: 1,
            width: "100%",
            borderRadius: 0,
            justifyContent: "flex-start",
            gap: 1,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: theme.palette.primary.main,
              color: "#fff",
              borderRadius: "10px",
              border: "1px solid #ccc",
              minWidth: "34px ",
              maxWidth: "34px ",
              minHeight: "34px",
              maxHeight: "34px",
              fontSize: "16px",
            }}
          >
            {user.first_name.slice(0, 1)}
            {user.last_name.slice(0, 1)}
          </Box>
          <UserBoxText
            sx={{
              display: { xs: "none", md: "block" },
            }}
          >
            <UserBoxLabel variant="body1">{user.display_name}</UserBoxLabel>
            <UserBoxDescription variant="body2">
              {user.title}
            </UserBoxDescription>
          </UserBoxText>
        </Button>
      </UserBoxButton>
      <Popover
        disableScrollLock
        anchorEl={ref.current}
        onClose={handleClose}
        open={isOpen}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuUserBox
          sx={{
            minWidth: 210,
          }}
          display="flex"
        >
          <Avatar variant="rounded" alt={user.display_name} src={user.avatar} />
          <UserBoxText>
            <UserBoxLabel variant="body1">{user.display_name}</UserBoxLabel>
            <UserBoxDescription variant="body2">
              {user.title}
            </UserBoxDescription>
          </UserBoxText>
        </MenuUserBox>
        <Divider
          sx={{
            mb: 0,
          }}
        />
        <Box m={1}>
          <Button color="primary" fullWidth onClick={handleSecurity}>
            <SecurityIcon
              sx={{
                mr: 1,
              }}
            />
            {t("Güvenlik")}
          </Button>
        </Box>
        <Box m={1}>
          <Button color="primary" fullWidth onClick={handleLogout}>
            <LockOpenTwoToneIcon
              sx={{
                mr: 1,
              }}
            />
            {t("Çıkış Yap")}
          </Button>
        </Box>
      </Popover>
    </>
  );
}

export default HeaderUserbox;
